import {Component, effect, inject, OnInit, signal, ViewChild} from '@angular/core';
import {FormsModule, NgForm, ReactiveFormsModule} from "@angular/forms";
import {NgbNav, NgbNavContent, NgbNavItem, NgbNavLinkButton, NgbNavOutlet} from "@ng-bootstrap/ng-bootstrap";
import {
  BudgetYearMonth,
  ProcessPointRound,
  SrmPointSummaryReportSearchParam,
  UserData
} from "../../../../../generated-model/model";
import {SrmPointSummaryReportResource} from "../../../../service/SrmPointSummaryReportResource";
import {
  PointSummaryReportTableComponent
} from "../../../../shared/components/point-summary-report-table/point-summary-report-table.component";
import {SelectZoneComponent} from "../../../../shared/components/select-zone/select-zone.component";
import {
  ProvinceAutocompleteComponent
} from "../../../../shared/components/province-autocomplete/province-autocomplete.component";
import {KeyValuePipe, NgIf} from "@angular/common";
import {scrollToInvalidElement, updateFormAndValidity} from "../../../../app.constants";
import {ToastService} from "../../../../shared/commons/toast/toast-service";
import {CustomErrorComponent} from "../../../../shared/commons/custom-error.component";
import {
  HospitalAutocompleteComponent
} from "../../../../shared/components/hospital-autocomplete/hospital-autocomplete.component";
import {UserDataService} from "../../../../security/user-data.service";
import {HasAnyAuthorityDirective} from "../../../../security/has-any-authority.directive";
import {
  PointSummaryReportBkkTableComponent
} from "../../../../shared/components/point-summary-report-bkk-table/point-summary-report-bkk-table.component";

@Component({
  selector: 'app-point-summary-report',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    PointSummaryReportTableComponent,
    SelectZoneComponent,
    ProvinceAutocompleteComponent,
    KeyValuePipe,
    CustomErrorComponent,
    NgIf,
    HospitalAutocompleteComponent,
    HasAnyAuthorityDirective,
    NgbNavOutlet,
    NgbNav,
    NgbNavItem,
    NgbNavLinkButton,
    NgbNavContent,
    PointSummaryReportBkkTableComponent
  ],
  templateUrl: './point-summary-report.component.html',
  styleUrl: './point-summary-report.component.scss'
})
export class PointSummaryReportComponent implements OnInit {
  @ViewChild("searchForm", {read: NgForm, static: false}) searchForm: NgForm;
  params: SrmPointSummaryReportSearchParam = {};
  srmPointSummaryReportResource = inject(SrmPointSummaryReportResource);
  toastService = inject(ToastService);
  userDataService = inject(UserDataService);
  userData = signal<UserData>(undefined);
  budgetYearMonth = signal<{ [id: number]: BudgetYearMonth[] }>({});
  currentRound = signal<ProcessPointRound>(undefined);
  budgetYearMonthList = signal<BudgetYearMonth[]>([]);
  defaultBudgetYear: number;
  defaultMonth: string;
  defaultRound: string;
  defaultBudgetYearMonth: { [id: number]: BudgetYearMonth[] };
  active = 1;
  @ViewChild("searchReportProvince") searchReportProvince: PointSummaryReportTableComponent;
  @ViewChild("searchReportBkk") searchReportBkk: PointSummaryReportBkkTableComponent;

  constructor() {
    effect(() => {
      this.params;
    });
  }

  ngOnInit(): void {
    this.userDataService.getCurrent()
      .subscribe(value => {
        this.userData.set(value);
        if (this.userData()?.authorities?.map(e => e.authority).includes('hospital')) {
          this.params.hospital = {hcode: this.userData().organization?.id, hname: this.userData().organization?.name};
        }
      });
    this.srmPointSummaryReportResource.getBudgetMonth()
      .subscribe(value => {
        this.budgetYearMonth.set(value);
        this.defaultBudgetYearMonth = value;
        let defaultBudgetYear = Math.max(...Object.keys(this.budgetYearMonth()).map(e => +e));
        if (defaultBudgetYear) {
          this.defaultBudgetYear = +defaultBudgetYear;
          console.log('this.defaultBudgetYear 1 ', this.defaultBudgetYear);
          this.params.budgetYear = this.defaultBudgetYear;
          this.budgetYearMonthList.set(
            [...this.budgetYearMonth()[this.params.budgetYear - 1], ...this.budgetYearMonth()[this.params.budgetYear]]
          )
          this.budgetYearMonthList().sort((a, b) => {
            let aa = (a.year + "" + a.month);
            let bb = (b.year + "" + b.month);
            return aa.localeCompare(bb);
          });
          this.srmPointSummaryReportResource.getCurrentRound()
            .subscribe(currentRound => {
              this.currentRound.set(currentRound);
              if (this.currentRound()) {
                this.defaultMonth = this.currentRound().month;
                this.defaultRound = this.currentRound().round;
                this.params.month = this.defaultMonth;
                this.params.round = this.defaultRound;
                this.searchReportProvince.searchProvince(1);
                this.searchReportBkk.searchBkk(1);
              }
            });
        }
      });
  }

  submit() {
    let valid = updateFormAndValidity(this.searchForm);
    if (valid) {
      console.log('valid')
      this.searchReportProvince.searchProvince(1);
      this.searchReportBkk.searchBkk(1);
    } else {
      console.log('invalid')
      this.toastService.showWarning("กรุณากรอกข้อมูลให้ครบถ้วน");
      try {
        scrollToInvalidElement('search-form');
      } catch (e) {
        //do nothing.
      }
    }
  }

  reset() {
    this.params.zone = undefined;
    this.params.province = undefined;
    this.params.hospital = undefined;
    this.params.budgetYear = this.defaultBudgetYear;
    this.params.month = this.defaultMonth;
    this.params.round = this.defaultRound;
    this.budgetYearMonth.set(this.defaultBudgetYearMonth);
    this.budgetYearMonthList.set(this.budgetYearMonth()[this.params.budgetYear]);
    if (this.userData()?.authorities?.map(e => e.authority).includes('hospital')) {
      this.params.hospital = {hcode: this.userData().organization?.id, hname: this.userData().organization?.name};
    }
  }

  onSelectZone() {
    this.params.province = undefined;
  }

  onBudgetYearChange() {
    this.budgetYearMonthList.set(this.budgetYearMonth()[this.params.budgetYear]);
    this.params.month = undefined;
  }
}
